import { Upload } from 'antd';
import ImgCrop from 'antd-img-crop';
import React, { useEffect, useState } from 'react';
import { Button, Col, Form, FormGroup, Input, Label, Row } from 'reactstrap';
import blankEventImage from '../../../assets/images/MettaMateImages/eventSamples/defaultEventThumbnail.png';
import FeatherIcon from 'feather-icons-react';
import PlacesAutocomplete, {
  geocodeByAddress,
  getLatLng,
} from 'react-places-autocomplete';
import eventtitleicon from '../../../assets/images/event/eventtitleicon.png';
import TimezoneSelect from 'react-timezone-select';
import CommonModal from '../../Home/modal';
import axios from 'axios';
import apiUrl from 'apppages/server';

const EventForm = ({ selectedEvent, formNavigate }) => {
  const [EventAddress, setEventAddress] = useState('');
  const [currentmapvalue, setcurrentmapValue] = useState(null);
  const [currentcity, setcurrentCity] = useState('');
  const [currentstate, setcurrentState] = useState('');
  const [currentcountry, setcurrentCountry] = useState('');
  const [userData, setUserData] = useState(
    JSON.parse(localStorage.getItem('configurationData')),
  );
  const [formData, setFormData] = useState({
    eventtitle: '',
    eventdetails: '',
    eventstartdate: '',
    eventstarttime: '',
    eventenddate: '',
    eventendtime: '',
    // eventcategory: '',
    eventorgurl: '',
    eventticketurl: '',
    // eventday: '',
    eventtype: '',
    eventstatus: 'Pending',
    fulldayevent: false,
    halfdayevent: false,
    multidayevent: false,
    eventlocation: '',
    listeventcategories: [],
    eventimagepath: '',
    eventtype: '',
    memberuuid: localStorage.getItem('memberID'),
    eventtimezone: '',
  });
  const [fileList, setFileList] = useState([]);
  const [eventData, setEventData] = useState({
    eventstartdate: '',
    eventstarttime: '',
    timeZone: 'UTC', // Default timezone
  });
  const [modalMessage, setModalMessage] = useState(false);
  const [errorModalMessage, setErrorModalMessage] = useState(false);
  const [successMessage, setSuccessMessage] = useState(false);

  const [eventcategoryList, setEventCategoryList] = useState([]);
  const [selectedCategories, setSelectedCategories] = useState([]);

  useEffect(() => {
    fetchAllCategories();
    if (selectedEvent != null || selectedEvent) {
      setFormData(selectedEvent);
      setSelectedCategories(selectedEvent.listeventcategories);
      setEventAddress(selectedEvent.eventlocation);
      handlePlaceId(selectedEvent.eventlocation);
      setcurrentmapValue(selectedEvent.eventlocation);
    }
  }, [selectedEvent]);

  const fetchAllCategories = () => {
    axios
      .get(`${apiUrl}eb/getebcategories`, {
        headers: {
          'Content-Type': 'application/json',
          authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      })
      .then((res) => setEventCategoryList(res.data))
      .catch((err) => console.error(err));
  };

  const handleEventAddressSelect = async (address, placeid) => {
    setcurrentmapValue(placeid);
    try {
      const results = await geocodeByAddress(address);
      const latLng = await getLatLng(results[0]);

      setEventAddress(address);
      const addressComponents = results[0].address_components;
      const city =
        addressComponents.find((component) =>
          component.types.includes('locality'),
        )?.long_name || '';
      const state =
        addressComponents.find((component) =>
          component.types.includes('administrative_area_level_1'),
        )?.long_name || '';
      const country =
        addressComponents.find((component) =>
          component.types.includes('country'),
        )?.long_name || '';

      // Store the city, state, and country in your state or do something else with this information
      setcurrentCity(city);
      setcurrentState(state);
      setcurrentCountry(country);
      const locationname = [city, state, country].filter(Boolean).join(", ");	
      setEventAddress(locationname);
    } catch (error) {
      console.error('Error selecting address:', error);
    }
  };

  const handleChange = ({ fileList }) => {
    console.log(fileList);

    setFileList(fileList);
  };
  const handleReset = () => {
    setFormData({
      eventtitle: '',
      eventdetails: '',
      eventstartdate: '',
      eventstarttime: '',
      eventenddate: '',
      eventendtime: '',
      // eventcategory: '',
      eventorgurl: '',
      eventticketurl: '',
      // eventday: '',
      eventtype: '',
      eventstatus: '',
      fulldayevent: false,
      halfdayevent: false,
      multidayevent: false,
      eventlocation: '',
      listeventcategories: [],
      eventimagepath: '',
      eventtype: '',
      useruuid: localStorage.getItem('memberID'),
      eventstatus: '',
      eventtimezone: '',
    });
    setEventAddress('');
    setSelectedCategories([]);
  };

  const handleUploadImage = (file) => {
    // Custom upload logic
    // For example, you can send the file to your server here
    // message.success(`${file.name} file uploaded successfully`);
  };

  const beforeUpload = (file) => {
    ``;
    const isImage = file.type.startsWith('image/');
    if (!isImage) {
      //   message.error('You can only upload image files!');
    }
    return isImage;
  };

  const changeHandler = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };
  const handleTimezoneChange = (eventtimezone) => {
    setFormData((prev) => ({
      ...prev,
      eventtimezone: eventtimezone.value,
    }));
  };

  const handleSelectCategory = (e) => {
    const newValue = e.target.value;
    setSelectedCategories((prevSelectedCategories) => {
      if (e.target.checked) {
        // If checked, add the new category if it's not already in the array
        return prevSelectedCategories.includes(newValue)
          ? prevSelectedCategories
          : [...prevSelectedCategories, newValue];
      } else {
        // If unchecked, remove the category
        return prevSelectedCategories.filter(
          (category) => category !== newValue,
        );
      }
    });
  };

  const uploadEventImage = (eventuuid) => {
    const formData1 = new FormData();
    formData1.append('ebimage', fileList[0]?.originFileObj);
    formData1.append('eventuuid', eventuuid);
    // formData1.append('imageindex', '0');
    axios
      .post(apiUrl + 'eb/uploadEBImage', formData1, {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: 'Bearer' + ' ' + localStorage.getItem('token'),
        },
      })
      .then((res) => {
        setSuccessMessage({
          title: 'Success!',
          message: 'Event Upated Successfully !',
        });
        setTimeout(() => {
          formNavigate();
        }, 2000);
      })
      .catch((err) => console.error(err));
  };

  const handleSubmit = () => {
    console.log(currentmapvalue);

    formData.eventlocation = currentmapvalue;
    formData.listeventcategories = selectedCategories;
    formData.eventstartdate = formatDate(formData.eventstartdate);
    formData.eventenddate = formatDate(formData.eventenddate);

    if (
      formData.listeventcategories.length === 0 ||
      !formData.eventtype
      // !formData.eventstatus
    ) {
      setErrorModalMessage({
        title: 'Error',
        message: 'Please fill all the details !',
      });
      return;
    }

    //Updating Event
    if (selectedEvent != null || selectedEvent) {
      if (fileList.length) {
        uploadEventImage(selectedEvent.eventuuid);
      }
      axios
        .put(`${apiUrl}eb/updateebpost/${selectedEvent.eventuuid}`, formData, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
            'Content-Type': 'application/json',
          },
        })
        .then((res) => {
          console.log(res);
          setSuccessMessage({
            title: 'Success!',
            message: 'Event Upated Successfully !',
          });
          setTimeout(() => {
            formNavigate();
          }, 2000);
        })
        .catch((error) => console.error(error));
    } else {
      //Adding Event
      axios
        .post(`${apiUrl}eb/addebpost`, formData, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
            'Content-Type': 'application/json',
          },
        })
        .then((res) => {
          if (res.data.length) {
            if (fileList.length) {
              uploadEventImage(res.data[0].eventuuid);
            }
            console.log(res.data[0].eventuuid);
            setSuccessMessage({
              title: 'Success!',
              message: 'Event Added Successfully !',
            });
            setTimeout(() => {
              formNavigate();
            }, 3000);
          }
        })
        .catch((error) => console.error(error));
    }
  };

  function formatDate(dateString) {
    if (!dateString) return '';
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
    const year = date.getFullYear();

    return `${day}-${month}-${year}`;
  }

  const getTodayDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
    const day = String(today.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  return (
    <>
      <Form
        // className="my-2"
        onSubmit={(e) => {
          e.preventDefault();
          handleSubmit();
          return false;
        }}
      >
        <Row className="inner_row m-0 mt-1">
          {modalMessage && (
            <CommonModal
              title={modalMessage.title}
              message={modalMessage.message}
              // onClose={successHandler}
              status="success"
            />
          )}
          {errorModalMessage && (
            <CommonModal
              title={errorModalMessage.title}
              message={errorModalMessage.message}
              onClose={() => setErrorModalMessage(false)}
              status="error"
            />
          )}
          {successMessage && (
            <CommonModal
              title={successMessage.title}
              message={successMessage.message}
              onClose={() => setSuccessMessage(false)}
              status="success"
            />
          )}

          {/* <Form
          // className="my-2"
          onSubmit={(e) => {
            e.preventDefault();
            handleSubmit();
            return false;
          }}
        > */}
          <h5 className="title title_bar">
            {/* <FeatherIcon icon="calendar" className="fea icon-sm me-1" /> */}
            <img
              // src="https://cdn-icons-png.flaticon.com/512/1055/1055650.png"
              src={eventtitleicon}
              height={40}
              width={40}
            />
            &nbsp; Add Event
          </h5>

          <Col md={6} className="mt-3">
            {/* <img src={NameIcon} className='legendIcon' /> */}
            {/* <svg
              width="24"
              height="26"
              viewBox="0 0 24 26"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M14.4804 20.0019L14.7504 19.9999C15.9704 19.9999 16.6124 20.5059 17.4034 21.7039L17.7964 22.3119C18.1034 22.7669 18.2954 22.9569 18.5364 23.0569C18.9694 23.2349 19.3284 23.1469 20.6454 22.5129L21.0484 22.3169C21.8724 21.9129 22.4344 21.6809 23.0684 21.5219C23.2614 21.4736 23.4658 21.504 23.6364 21.6064C23.8071 21.7088 23.9301 21.8748 23.9784 22.0679C24.0266 22.261 23.9962 22.4653 23.8938 22.636C23.7914 22.8066 23.6254 22.9296 23.4324 22.9779C23.0384 23.0759 22.6604 23.2179 22.1654 23.4459L21.0064 24.0029C19.4384 24.7429 18.9064 24.8319 17.9654 24.4429C17.3404 24.1859 16.9854 23.8129 16.4654 23.0179L16.2704 22.7139C15.6684 21.7659 15.3654 21.4999 14.7504 21.4999L14.5924 21.5039C14.1594 21.5299 13.8784 21.7279 12.0104 23.1139C10.2684 24.4079 8.93935 25.0249 7.25035 25.0249C5.19035 25.0249 3.24835 24.6469 1.43235 23.8899L4.31435 23.2239C5.25835 23.4239 6.23635 23.5249 7.24935 23.5249C8.53935 23.5249 9.60935 23.0279 11.1164 21.9099L12.2764 21.0539C13.5474 20.1299 13.8304 20.0159 14.4804 20.0019ZM20.7784 2.22189C21.5817 3.02562 22.033 4.1155 22.033 5.25189C22.033 6.38829 21.5817 7.47816 20.7784 8.28189L19.7424 9.31789C20.8944 10.7199 20.8524 12.2049 19.7824 13.2789L16.7814 16.2809C16.7116 16.3505 16.6289 16.4057 16.5378 16.4433C16.4467 16.4809 16.3492 16.5002 16.2506 16.5001C16.1521 16.5 16.0546 16.4805 15.9636 16.4428C15.8726 16.405 15.79 16.3496 15.7204 16.2799C15.6508 16.2102 15.5956 16.1274 15.558 16.0363C15.5203 15.9453 15.501 15.8477 15.5011 15.7492C15.5012 15.6507 15.5207 15.5531 15.5585 15.4621C15.5963 15.3711 15.6516 15.2885 15.7214 15.2189L18.7204 12.2199C19.2054 11.7339 19.2604 11.1299 18.6804 10.3819L8.08535 20.9759C7.78714 21.2739 7.41118 21.4822 7.00035 21.5769L0.920352 22.9809C0.796311 23.0096 0.66699 23.0063 0.544575 22.9713C0.422161 22.9363 0.310683 22.8706 0.220647 22.7806C0.13061 22.6906 0.0649785 22.5791 0.0299367 22.4567C-0.00510507 22.3343 -0.00840349 22.2049 0.0203523 22.0809L1.42335 16.0009C1.5179 15.5897 1.72616 15.2134 2.02435 14.9149L14.7174 2.22189C15.1153 1.82398 15.5876 1.50834 16.1075 1.29299C16.6274 1.07764 17.1846 0.966797 17.7474 0.966797C18.3101 0.966797 18.8673 1.07764 19.3872 1.29299C19.9071 1.50834 20.3805 1.82398 20.7784 2.22189Z"
                fill="#0D6EFD"
              />
            </svg>
            &nbsp; <span className="m-2 legendName">Your Full Name</span> */}
            <Row className="">
              <Col md={12} xs={12}>
                <div className="features feature-primary p-1">
                  <div className="mb-3">
                    <Label className="form-label label_text">Event Title</Label>
                    <div className="form-icon position-relative">
                      <FeatherIcon
                        icon="edit-3"
                        className="fea icon-sm icons"
                      />
                    </div>
                    <Input
                      type="text"
                      id="eventtitle"
                      className="form-control form_Input ps-5"
                      placeholder="Event Title"
                      value={formData.eventtitle}
                      // defaultValue={educationData.degreecollege || ''}
                      name="eventtitle"
                      onChange={changeHandler}
                      maxLength={64}
                      required
                    />
                  </div>
                </div>
              </Col>

              <Col md={12} xs={12}>
                <div className="features feature-primary p-1">
                  <div className="mb-3">
                    <Label className="form-label label_text">
                      Event Description
                    </Label>
                    <div className="form-icon position-relative">
                      <FeatherIcon
                        icon="align-center"
                        className="fea icon-sm icons"
                      />
                    </div>
                    <Input
                      type="textarea"
                      row={2}
                      id="eventdetails"
                      className="form-control form_Input ps-5"
                      placeholder="Event Description"
                      maxLength={256}
                      value={formData.eventdetails}
                      // defaultValue={educationData.degreecollege || ''}
                      name="eventdetails"
                      onChange={changeHandler}
                      required
                    />
                  </div>
                </div>
              </Col>

              <Col md={6} xs={12}>
                <div className="features feature-primary p-1">
                  <div className="mb-3">
                    <Label className="form-label label_text">
                      Event Start Date
                      <br />
                      <Input
                        type="date"
                        className="form-control w-100"
                        name="eventstartdate"
                        onChange={changeHandler}
                        value={formData.eventstartdate || getTodayDate()}
                        required
                      />
                    </Label>
                  </div>
                </div>
              </Col>
              <Col md={6} xs={12}>
                <div className="features feature-primary p-1">
                  <div className="mb-3">
                    <Label className="form-label label_text">
                      Event End Date
                      <br />
                      <input
                        type="date"
                        className="form-control w-100"
                        name="eventenddate"
                        onChange={changeHandler}
                        value={formData.eventenddate || getTodayDate()}
                        required
                        // defaultValue={personalFormData.dob}
                        // onChange={(event) =>
                        //   setPersonalFormData({
                        //     ...personalFormData,
                        //     dob: event.target.value,
                        //   })
                        // }
                      />{' '}
                    </Label>
                  </div>
                </div>
              </Col>
              <Col md={6} xs={12}>
                <div className="features feature-primary p-1">
                  <div className="mb-3">
                    <Label className="form-label label_text">Time Zone</Label>
                    <br />
                    <TimezoneSelect
                      value={formData.eventtimezone}
                      onChange={handleTimezoneChange}
                      timeZone={formData.eventtimezone}
                      required
                    />
                  </div>
                </div>
              </Col>
              <Col md={3} xs={12}>
                <div className="features feature-primary p-1">
                  <div className="mb-3">
                    <Label
                      className="form-label label_text"
                      style={{ whiteSpace: 'nowrap' }}
                    >
                      Event Start Time
                    </Label>
                    <br />
                    <Input
                      type="time"
                      className="form-control"
                      name="eventstarttime"
                      onChange={changeHandler}
                      value={formData.eventstarttime}
                      required
                    />
                  </div>
                </div>
              </Col>
              <Col md={3} xs={12}>
                <div className="features feature-primary p-1">
                  <div className="mb-3">
                    <Label className="form-label label_text">
                      Event End Time
                    </Label>
                    <br />
                    <input
                      type="time"
                      className="form-control"
                      name="eventendtime"
                      onChange={changeHandler}
                      value={formData.eventendtime}
                      required
                      // defaultValue={personalFormData.dob}
                      // onChange={(event) =>
                      //   setPersonalFormData({
                      //     ...personalFormData,
                      //     dob: event.target.value,
                      //   })
                      // }
                    />
                  </div>
                </div>
              </Col>
              <Col md={12} sm={12}>
                <div className=" features feature-primary p-1">
                  <div className="mb-3">
                    <Label className="form-label label_text">
                      Event Location
                    </Label>
                    <PlacesAutocomplete
                      value={EventAddress}
                      onChange={(newAddress) => setEventAddress(newAddress)}
                      onSelect={handleEventAddressSelect}
                      className="form-control form_input"
                    >
                      {({
                        getInputProps,
                        suggestions,
                        getSuggestionItemProps,
                        loading,
                      }) => {
                        const uniqueSuggestions = new Set();

                        return (
                          <div>
                            <input
                              {...getInputProps({
                                placeholder: 'Search Places ...',
                                className: 'location-search-input',
                              })}
                            />
                            <div className="autocomplete-dropdown-container">
                              {loading && <div>Loading...</div>}
                              {suggestions.map((suggestion, index) => {
                                const className = suggestion.active
                                  ? 'suggestion-item--active'
                                  : 'suggestion-item';

                                const words = suggestion.description.split(',');
                                const trimmedArray = words.map((str) =>
                                  str.trim(),
                                );
                                const lastThreeWords = trimmedArray
                                  .slice(-3)
                                  .join(',');
                                // Check if the suggestion is unique based on place_id
                                if (!uniqueSuggestions.has(lastThreeWords)) {
                                  uniqueSuggestions.add(lastThreeWords);

                                  // inline style for demonstration purpose
                                  const style = suggestion.active
                                    ? {
                                        backgroundColor: '#fafafa',
                                        cursor: 'pointer',
                                      }
                                    : {
                                        backgroundColor: '#ffffff',
                                        cursor: 'pointer',
                                      };

                                  return (
                                    <div
                                      key={index}
                                      {...getSuggestionItemProps(suggestion, {
                                        className,
                                        style,
                                      })}
                                    >
                                      <span>{lastThreeWords}</span>
                                    </div>
                                  );
                                } else {
                                  return null; // Skip rendering duplicate suggestions
                                }
                              })}
                            </div>
                          </div>
                        );
                      }}
                    </PlacesAutocomplete>
                  </div>
                </div>
              </Col>
              {/* <Col md={6} xs={12}>
              <div className="features feature-primary p-1 mt-4">
                <div className="mb-3">
                  <Label className="form-label label_text">
                    Event Category
                  </Label>

                  <select
                    className="form-select form-control form_Input"
                    id="degreeyear"
                    name="eventcategory"
                    onChange={changeHandler}
                    // value={graduationyear}
                    // onChange={(e) => setGraduationYear(e.target.value)}
                  >
                    <option value={''}>Select Category</option>
                    {(
                      [
                        {
                          value: 1,
                          label: 'Category',
                        },
                        {
                          value: 2,
                          label: 'Category',
                        },
                        {
                          value: 3,
                          label: 'Category',
                        },
                        {
                          value: 4,
                          label: 'Category',
                        },
                      ] || []
                    ).map((item, key) => (
                      <option key={key} value={item.value}>
                        {item.label}
                        {key}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </Col> */}

              <Col md={12} xs={12}>
                <div className="features feature-primary p-1">
                  <div className="mb-3">
                    <Label className="form-label label_text">
                      Organization URL
                    </Label>
                    <div className="form-icon position-relative">
                      <FeatherIcon
                        icon="link-2"
                        className="fea icon-sm icons"
                      />
                    </div>
                    <Input
                      type="text"
                      id="eventorgurl"
                      className="form-control form_Input ps-5"
                      placeholder="Organization URL"
                      // defaultValue={educationData.degreecollege || ''}
                      name="eventorgurl"
                      onChange={changeHandler}
                      value={formData.eventorgurl}
                      maxLength={255}
                      required
                    />
                  </div>
                </div>
              </Col>

              <Col md={12} xs={12}>
                <div className="features feature-primary p-1">
                  <div className="mb-3">
                    <Label className="form-label label_text">Ticket URL</Label>
                    <div className="form-icon position-relative">
                      <FeatherIcon
                        icon="link-2"
                        className="fea icon-sm icons"
                      />
                    </div>
                    <Input
                      type="text"
                      id="eventticketurl"
                      className="form-control form_Input ps-5"
                      placeholder="Ticket URL"
                      // defaultValue={educationData.degreecollege || ''}
                      name="eventticketurl"
                      onChange={changeHandler}
                      maxLength={255}
                      value={formData.eventticketurl}
                      required
                    />
                  </div>
                </div>
              </Col>

              <Col md={12} className="fieldset mt-4 mx-2">
                <div className="legend">Event Category</div>
                <div className="my-3 row ms-2">
                  {eventcategoryList.length &&
                    eventcategoryList.map((type, key) => (
                      <FormGroup key={key} className="col-md-4 col-sm-6">
                        <Label className="form-label label_text">
                          <Input
                            type="checkbox"
                            name="option1"
                            value={type.categoryuuid}
                            size="md"
                            // checked={checkedItems.option1 || false}
                            onChange={handleSelectCategory}
                            checked={selectedCategories.includes(
                              type.categoryuuid,
                            )}
                          />
                          &nbsp;{type.categoryname}
                        </Label>
                      </FormGroup>
                    ))}
                </div>
              </Col>
            </Row>
          </Col>

          <Col md={6} className="">
            <Row className="m-0  inner_row_personal d-flex justify-content-center">
              {/* <h5 className="title title_bar text-center">Upload Event Photos</h5> */}

              <Col md={6} className="text-center mb-5">
                <div
                  className="fieldset shadow"
                  style={{ background: `white` }}
                >
                  <div
                    className="legend text-left text-primary"
                    style={{ top: `-4px` }}
                  >
                    Upload Photo
                  </div>
                  <div className="uploadimg_div mt-2 ">
                    <ImgCrop
                      showGrid
                      rotationSlider
                      showReset
                      remove={false}
                      aspect={1 / 1}
                    >
                      <Upload
                        id="profileimage"
                        listType="picture-card"
                        onChange={handleChange}
                        fileList={fileList}
                        maxCount={1}
                        // src={fileList}
                        // customRequest={({ file, onSuccess }) => {
                        //   handleUploadImage(file);
                        //   onSuccess(null, file);
                        // }}
                        // beforeUpload={beforeUpload}
                        // onRemove={() => {
                        //   setFileList([]);
                        // }}
                        //   fileList={[
                        //     {
                        //       uid: '-1',
                        //       name: 'image.png',
                        //       status: 'done',
                        //       url: 'https://media.istockphoto.com/id/1147544807/vector/thumbnail-image-vector-graphic.jpg?s=612x612&w=0&k=20&c=rnCKVbdxqkjlcs3xH87-9gocETqpspHFXu5dIGB4wuM=',
                        //     },
                        //   ]}
                        // onChange={handleChange(setFile1, 0)}
                        // onPreview={onPreview}
                        // customRequest={(file) => handleUploadImage(file, 0)}
                        // onRemove={() => {
                        //   showDeleteConfirm(file1[0], 0);
                        // }}
                      >
                        {fileList.length === 0 && (
                          <div>
                            <img
                              className=""
                              style={{
                                width: '100%',
                                height: '258px',
                                opacity: `0.5`,
                              }}
                              src={
                                'https://media.istockphoto.com/id/1147544807/vector/thumbnail-image-vector-graphic.jpg?s=612x612&w=0&k=20&c=rnCKVbdxqkjlcs3xH87-9gocETqpspHFXu5dIGB4wuM='
                              }
                            />
                          </div>
                        )}
                      </Upload>
                    </ImgCrop>
                  </div>

                  <div className="text-center">
                    {/* {file1.length < 1 && (
                      <Button
                        onClick={openSelectionform1}
                        icon={<UploadOutlined />}
                      >
                        Upload
                      </Button>
                    )} */}
                    {/* {file1.length > 0 && ( */}
                    <Button
                      onClick={() => {
                        setFileList([]);
                      }}
                      style={{ marginLeft: '5px' }}
                    >
                      Delete
                    </Button>
                    {/* )} */}
                  </div>
                </div>
              </Col>
              {/* <Label className="form-label label_text">
                        
                      </Label> */}
              <Col md={12} className="fieldset mt-1">
                <div className="legend">Event Schedule</div>
                <Row className="">
                  {' '}
                  <Col md={12} xs={12}>
                    <div className="features feature-primary p-1">
                      <div className="my-3">
                        <section className="radio-section">
                          <div className="radio-list">
                            {(
                              [
                                {
                                  value: 1,
                                  label: 'Full Day Event',
                                  name: 'fulldayevent',
                                },
                                {
                                  value: 2,
                                  label: 'Half Day Event',
                                  name: 'halfdayevent',
                                },
                                {
                                  value: 3,
                                  label: 'Multi Day Event',
                                  name: 'multidayevent',
                                },
                              ] || []
                            ).map((type, index) => (
                              <div className="radio-item" key={index}>
                                <Input
                                  name="eventday"
                                  // onChange={changeHandler}
                                  type="radio"
                                  // value={type.value}
                                  checked={formData[type.name]}
                                  id={`eventdayradio${index}`}
                                  onChange={(e) =>
                                    setFormData((prevData) => ({
                                      ...prevData,
                                      [type.name]: true, // Use computed property name
                                    }))
                                  }
                                />
                                <label htmlFor={`eventdayradio${index}`}>
                                  {type.label}
                                </label>
                              </div>
                            ))}
                          </div>
                        </section>
                      </div>
                    </div>
                  </Col>
                </Row>
              </Col>

              <Col md={12} className="fieldset mt-1">
                <div className="legend">Event Type</div>
                <Row className="">
                  <Col md={12} xs={12}>
                    <div className="features feature-primary p-1">
                      <div className="my-3">
                        <section className="radio-section">
                          <div className="radio-list">
                            {(
                              [
                                {
                                  value: 1,
                                  label: 'virtual',
                                },
                                {
                                  value: 2,
                                  label: 'in-person',
                                },
                                {
                                  value: 3,
                                  label: 'mix',
                                },
                              ] || []
                            ).map((type, index) => (
                              <div className="radio-item" key={index}>
                                <Input
                                  name="eventtype"
                                  onChange={changeHandler}
                                  type="radio"
                                  value={type.label}
                                  checked={
                                    formData.eventtype?.toLowerCase() ==
                                    type.label?.toLowerCase()
                                  }
                                  id={`radiolevel${index}`}
                                />
                                <label htmlFor={`radiolevel${index}`}>
                                  {' '}
                                  {type.label}
                                </label>
                              </div>
                            ))}
                          </div>
                        </section>
                      </div>
                    </div>
                  </Col>
                </Row>
              </Col>

              {/* <Col md={12} className="fieldset mt-1">
                <div className="legend">Event Status</div>
                <Row className="">
                  <Col md={12} xs={12}>
                    <div className="features feature-primary p-1">
                      <div className="my-3">
                        
                        <section className="radio-section">
                          <div className="radio-list">
                            {(
                              [
                                {
                                  value: 1,
                                  label: 'Pending',
                                  colorcode: '#FFBF00',
                                  labelcolorcode: 1,
                                },
                                {
                                  value: 2,
                                  label: 'Approved',
                                  colorcode: '#008000',
                                  labelcolorcode: 5,
                                },
                                {
                                  value: 3,
                                  label: 'Removed',
                                  colorcode: '#964B00',
                                  labelcolorcode: 3,
                                },
                                {
                                  value: 4,
                                  label: 'Rejected',
                                  colorcode: '#ff0000',
                                  labelcolorcode: 7,
                                },
                              ] || []
                            ).map((type, index) => (
                              <div className="radio-item" key={index}>
                                <Input
                                  name="eventstatus"
                                  onChange={changeHandler}
                                  type="radio"
                                  value={type.label}
                                  checked={formData.eventstatus?.toLowerCase() == type.label?.toLowerCase()}
                                  id={`statusradio${index}`}
                                // onChange={handledegreelevelOptionChange}
                                />
                                <label
                                  htmlFor={`statusradio${index}`}
                                  style={{ color: type.colorcode }}
                                  className={`labelcolor` + type.labelcolorcode}
                                >
                                  {' '}
                                  {type.label}
                                </label>
                              </div>
                            ))}
                          </div>
                        </section>
                      </div>
                    </div>
                  </Col>
                </Row>
              </Col> */}
            </Row>
          </Col>
          <div className="mt-md-4 mt-3 mb-2 mt-sm-0 text-md-end">
            <button type="submit" className="btn btn-outline-primary mt-2 ">
              {' '}
              Save Changes{' '}
            </button>{' '}
            <button
              type="reset"
              onClick={handleReset}
              className="btn btn-outline-secondary mt-2 ms-2  "
            >
              Reset
            </button>
          </div>
          {/* </Form> */}
        </Row>
      </Form>
    </>
  );
};

export default EventForm;
